import { Module } from "wrapper6";
import Swiper from 'swiper/bundle';
import {debounce} from '../utils/_debounce';

import 'core-js/es6/number';

var $ = jQuery;

export default class LexiconSlider extends Module {

	ready(app) {        

		if (document.querySelector('.mtt-lexicon-slider')) {
            this.SWIPER = new Swiper('.mtt-lexicon-slider .swiper-container', { 
                spaceBetween: 27,
                slidesPerView: 1,
                breakpoints: {                                                            
                    650: {
                        slidesPerView: 2,
                    },
                    1100: {
                      slidesPerView: 3,
                    },
                    1400: {
                        slidesPerView: 4,
                    }
                },
                navigation: {
                  nextEl: '.mtt-lexicon-slider__arrow.arrow-right',
                  prevEl: '.mtt-lexicon-slider__arrow.arrow-left',
                },                           
            });

            this.toggleArrows(); 

            window.addEventListener('resize', debounce(() => {
                this.toggleArrows();     
            }, 200));
        }

    }

    toggleArrows() {
        if (this.SWIPER.isBeginning && this.SWIPER.isEnd) {
            document.querySelector('.mtt-lexicon-slider__arrows').classList.add('hide');
        } else {
            document.querySelector('.mtt-lexicon-slider__arrows').classList.remove('hide');
        }   
    }
}